import { render, staticRenderFns } from "./AwardDetail.vue?vue&type=template&id=7b70ea4c&scoped=true"
import script from "./AwardDetail.vue?vue&type=script&lang=js"
export * from "./AwardDetail.vue?vue&type=script&lang=js"
import style0 from "./AwardDetail.vue?vue&type=style&index=0&id=7b70ea4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b70ea4c",
  null
  
)

export default component.exports